export default {"src":"/_next/static/media/right_arrow_circle.2dee7b3a.svg","height":32,"width":32};